import { SET_ABOUT } from '../constants/index';
import makeReducer from '../../utils/fabrickReducer';

const initialState = {
  text: '',
  showModalAbout: false
};

export default makeReducer(initialState, SET_ABOUT);
